import { IndicatorType } from '../../constants/common'
import IndicatorBaseConfig from './indicatorBaseConfig'

export type Options = {
  period: number
  dPeriod: number
  kPeriod: number
}

export type Attrs = Options

export class StofuConfig extends IndicatorBaseConfig {
  static type = IndicatorType.Stofu
  static abbreviation = 'stofu'
  static label = 'Stochastics FULL'
  static shortLabel = 'Stochastics FULL'
  static description =
    'The Stochastic Oscillator is a momentum indicator that compares the current closing price of a security to its price range over a specific period. It helps identify overbought and oversold conditions, as well as potential trend reversals.'

  static optionsOrder = ['period', 'dPeriod', 'kPeriod']
  static optionsLabels = { period: 'Period', kPeriod: 'K Period', dPeriod: 'D Period' } as { [key: string]: string }
  static inputsOrder = this.optionsOrder
  static inputsLabels = this.optionsLabels
  static calculatedValuesOrder = ['k', 'd'] as const
  static calculatedValuesLabels = { k: '%K', d: '%D' }
  static defaultCalculatedValueOption = this.calculatedValuesOrder[0]
}
